//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//firebase
import { db } from 'assets/firebase';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CategoryCreated, CategoriesLoaded, CategoryUpdated } from 'redux/actions';

// styles
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//spiffy
import CategoryEditor from "components/CategoryEditor/CategoryEditor.jsx";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";


const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class CategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: []
    }

    this.CategoryCreated = this.CategoryCreated.bind(this);
    this.CategoryUpdated = this.CategoryUpdated.bind(this);
    this.deleteCategory = this.deleteCategory.bind(this);
  }

  componentWillMount() {
    this.refreshCategories();
  }

  refreshCategories() {
    db.getCategories().then(objs => {
      this.setState({categories: objs});
      this.props.onCategoriesLoaded(objs);
    })
  }

  CategoryUpdated(obj) {
    var categories = this.state.categories;
    for(var i = 0; i < categories.length; i++) {
      if(categories[i].id === obj.id) {
        categories[i] = obj;
        break;
      }
    }
    categories = categories.sort(this.compareName);
    this.setState({categories: categories});
    this.props.onCategoriesLoaded(categories);
  }

  CategoryCreated(obj) {
    var categories = this.state.categories;
    categories.push(obj);
    categories = categories.sort(this.compareName);
    this.setState({categories: categories});
    this.props.onCategoriesLoaded(categories);
  }

  deleteCategory(obj) {
    db.deleteCategory(obj.id).then(() => {
      var categories = this.state.categories;
      for(var i = 0; i < categories.length; i++) {
        if(categories[i].id === obj.id) {
          categories.splice(i,1);
          break;
        }
      }

      categories = categories.sort(this.compareName);
      this.setState({categories: categories});
      this.props.onCategoriesLoaded(categories);
    });
  }

  compareName(a,b) {
    console.log(a)
    var aName = a.Name?.toString().toLowerCase();
    var bName = b.Name?.toString().toLowerCase();
  
    if (aName < bName)
      return -1;
    if (aName > bName)
      return 1;
    return 0;
  }

  trim(value, maxLength) {
    if(value) {
        if(value.length > maxLength)
            return value.substring(0,maxLength) + "...";
        else
            return value;
    } else return "";
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Categories</h4>
                  <p className={classes.cardCategoryWhite}>
                    This list allows products to be classified by categories and subcategories.
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <CategoryEditor title="Add Category" onCreated={this.CategoryCreated} />
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
              <GridItem xs={12}>
                <br />
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{padding:"6px", width:"23px"}}> 

                      </TableCell>
                      <TableCell style={{padding:"6px"}}> 
                        English
                      </TableCell>
                      <TableCell style={{padding:"6px"}}> 
                        # Subcategory A
                      </TableCell>
                      <TableCell style={{padding:"6px"}}> 
                        # Subcategory B
                      </TableCell>
                      <TableCell style={{padding:"6px"}}> 
                        # Subcategory C
                      </TableCell>
                      <TableCell style={{padding:"6px", width:"23px"}}> 
                          
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.categories.map(value => (
                      <TableRow key={value.id} className={classes.tableRow}>
                        <TableCell className={classes.tableActions} style={{padding:"6px", width:"23px"}}> 
                          <CategoryEditor title="Edit Category" category={value} onChanged={this.CategoryUpdated}  />
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"6px"}}> 
                          {value.Name}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"6px"}}> 
                          {value.SubCat1.length}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"6px"}}> 
                          {value.SubCat2.length}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"6px"}}> 
                          {value.SubCat3.length}
                        </TableCell>
                        <TableCell className={classes.tableActions} style={{padding:"6px", width:"23px"}}> 
                          <Tooltip id="tooltip-top-start" title="Delete Manufacturer" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this category? This action cannot be undone." confirmed={() => this.deleteCategory(value)} />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </GridItem>
            </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onCategoryCreated: CategoryCreated, 
    onCategoriesLoaded: CategoriesLoaded, 
    onCategoryUpdated: CategoryUpdated }, dispatch);  
}

CategoryList = connect(mapStateToProps, mapDispatchToProps)(CategoryList);
export default withStyles(styles)(CategoryList);
